import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Image, Row, Col } from 'react-bootstrap';
import VectorGnpIconWhite from "../../assests/images/gnp-vector-icon-white.svg";
import {
    PageWrapper,
    PageGroup,
    PageContentBox,
    PageText,
    PageTextImg,
    PageTitle,
    PageSubText,
    PageBackButton,
    BackButtonArrow,
} from './pageNotFoundStyle';
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
    const navigate = useNavigate()
    return (
        <PageWrapper>
            <Container className="cont-w">
                <Row>
                    <Col sm="12">
                        <PageGroup>
                            <PageContentBox>
                                <PageText>4</PageText>
                                <PageTextImg>
                                    <Image src={VectorGnpIconWhite} alt={VectorGnpIconWhite} />
                                </PageTextImg>
                                <PageText>4</PageText>
                            </PageContentBox>

                            <PageTitle>Page Not Found</PageTitle>
                            <PageSubText>The page you were looking for doesn't exist.</PageSubText>
                            <PageBackButton className="write-yellow-btn" onClick={() => navigate("/")}>
                                <BackButtonArrow>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <g id="vuesax_linear_home-2" data-name="vuesax/linear/home-2" transform="translate(-620 -188)">
                                            <g id="home-2">
                                                <path id="Vector" d="M7.02.823l-5.39,4.2A4.759,4.759,0,0,0,0,8.343v7.41a4.225,4.225,0,0,0,4.21,4.22H15.79A4.223,4.223,0,0,0,20,15.763V8.483a4.723,4.723,0,0,0-1.8-3.45L12.02.7A4.487,4.487,0,0,0,7.02.823Z" transform="translate(622 190.017)" fill="none" stroke="#333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                <path id="Vector-2" data-name="Vector" d="M0,3V0" transform="translate(632 202.99)" fill="none" stroke="#333" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
                                                <path id="Vector-3" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(620 188)" fill="none" opacity="0" />
                                            </g>
                                        </g>
                                    </svg>
                                </BackButtonArrow>
                                Back To Home</PageBackButton>
                        </PageGroup>
                    </Col>
                </Row>
            </Container>
        </PageWrapper >)
};

export default PageNotFound;